import { DeleteAlertReceiverReq, DeleteAlertReceiverRes, DeleteAlertRuleReq, DeleteAlertRuleRes, GetAllAlertReceiverReq, GetAllAlertReceiverRes, GetAllAlertRuleReq, GetAllAlertRuleRes, NewAlertReceiverReq, NewAlertReceiverRes, NewAlertRuleReq, NewAlertRuleRes, UpdateAlertReceiverReq, UpdateAlertReceiverRes, UpdateAlertRuleReq, UpdateAlertRuleRes } from "../interfaces/alert.interface";
import { GetAllLogPlatformsReq, GetAllLogPlatformsRes, UpdateLogPlatformReq, UpdateLogPlatformRes } from "../interfaces/logPlatform.interface";
import { API } from "./api";



export const getAllAlertReceiverService = async (data: GetAllAlertReceiverReq): Promise<GetAllAlertReceiverRes>=>{
    try {
        const res = await API.get(`/v1/alert-receiver`);
        return res.data;
    } catch (error) {
        throw error
    }
}

export const newAlertReceiverService = async (data: NewAlertReceiverReq): Promise<NewAlertReceiverRes>=>{
    try {
        const res = await API.post(`/v1/alert-receiver`, data);
        return res.data;
    } catch (error) {
        throw error
    }
}

export const updateAlertReceiverService = async (data: UpdateAlertReceiverReq): Promise<UpdateAlertReceiverRes>=>{
    try {
        const res = await API.put(`/v1/alert-receiver`, data);
        return res.data;
    } catch (error) {
        throw error
    }
}

export const deleteAlertReceiverService = async (data: DeleteAlertReceiverReq): Promise<DeleteAlertReceiverRes>=>{
    try {
        const res = await API.delete(`/v1/alert-receiver/${data.id}`);
        return res.data;
    } catch (error) {
        throw error
    }
}




export const getAllAlertRuleService = async (data: GetAllAlertRuleReq): Promise<GetAllAlertRuleRes>=>{
    try {
        const res = await API.get(`/v1/alert-rule`);
        return res.data;
    } catch (error) {
        throw error
    }
}

export const newAlertRuleService = async (data: NewAlertRuleReq): Promise<NewAlertRuleRes>=>{
    try {
        const res = await API.post(`/v1/alert-rule`, data);
        return res.data;
    } catch (error) {
        throw error
    }
}

export const updateAlertRuleService = async (data: UpdateAlertRuleReq): Promise<UpdateAlertRuleRes>=>{
    try {
        const res = await API.put(`/v1/alert-rule`, data);
        return res.data;
    } catch (error) {
        throw error
    }
}

export const deleteAlertRuleService = async (data: DeleteAlertRuleReq): Promise<DeleteAlertRuleRes>=>{
    try {
        const res = await API.delete(`/v1/alert-rule/${data.id}`);
        return res.data;
    } catch (error) {
        throw error
    }
}

